import React, { useCallback } from 'react';
import { Button } from '.';
import usePrefix from '@/hooks/usePrefix';
import PageLoader from '../shared/PageLoader';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

interface ConfirmModalProps {
  onSubmit: any;
  contentText?: React.ReactNode;
  cancelText?: string;
  submitText?: string;
  loading?: boolean;
  isInput?: boolean;
}

export default NiceModal.create(
  ({
    onSubmit,
    contentText = '是否保存本次编辑？',
    cancelText = '暂不',
    submitText = '保存',
    loading,
    isInput = false,
  }: ConfirmModalProps) => {
    const modal = useModal();
    const { prefix, classname } = usePrefix('bicester-modal');

    const handleSubmit = useCallback(() => {
      onSubmit?.();
      modal.hide();
    }, [onSubmit, modal]);

    return (
      <div className={classname}>
        {(modal.visible || loading) && (
          <div className="w-full h-screen fixed top-0 left-0 bg-black bg-opacity-40 flex justify-center items-center z-[999]">
            {loading ? (
              <PageLoader />
            ) : (
              <div className="flex flex-col items-center p-[40px] bg-[#fff]">
                <div
                  className={`w-full text-center text-[#999999] text-[16px] ${
                    isInput ? '' : 'py-[35px] px-[10px]'
                  }`}
                >
                  {contentText}
                </div>
                <div className="flex justify-between h-[33px] mt-[20px]">
                  <Button
                    className={`${prefix('btn')} ${prefix('cancel-btn')} mr-[35px]`}
                    onClick={modal.hide}
                  >
                    {cancelText}
                  </Button>
                  <Button className={prefix('btn')} onClick={handleSubmit}>
                    {submitText}
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
);
